/* DapperFam drawer behaviors v2.3 — loaded by header-mobile-menu.liquid.
   1. Expanding a category re-opens its Featured sub-accordion (theme's
      drawer-close animation strips `open` from all nested <details>).
   2. Sub-accordion summary taps are shielded from header.js's
      onSummaryClick (capture-phase stopPropagation) so toggling BRAND/
      COLOR doesn't trigger the drawer's scrollTop-reset — that reset
      should only fire when a category panel opens. Native <details>
      toggling is a default action, so it still works. */
(function () {
  function init() {
    var menu = document.getElementById('mobile-menu');
    if (!menu) return;
    menu.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.tagName !== 'DETAILS') return;
      if (d.open && d.classList.contains('link-container')) {
        var f = d.querySelector('details.dfm-subacc--featured');
        if (f) f.setAttribute('open', '');
      }
    }, true);
    menu.addEventListener('click', function (e) {
      if (e.target.closest('.dfm-subacc > summary')) e.stopPropagation();
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
